import type { SVGProps } from 'react';

export function Gradient(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={1480}
            height={980}
            viewBox="0 0 1480 980"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g filter="url(#filter0_f_300_5588)">
                <g filter="url(#filter1_f_300_5588)">
                    <path
                        d="M1142.98 -1110.85C1052.13 -1296.5 -469.127 -2176.99 -595.355 -2179.29C-843.054 -2183.8 -933.524 -107.814 -1008.16 -330.346C-1082.8 -552.878 -303.014 1211.26 317.1 -29.2131C472.898 -340.871 1152.01 406.65 1147.59 169.128C1145.28 45.5385 600.675 -413.367 489.312 -488.528C284.56 -722.556 1264.19 -966.493 1142.98 -1110.85Z"
                        fill="url(#paint0_linear_300_5588)"
                        fillOpacity={0.7}
                    />
                </g>
                <g filter="url(#filter2_f_300_5588)">
                    <path
                        d="M776.84 398.132C754.149 173.307 1119.95 -302.308 991.175 -352.786C738.484 -451.841 -171.877 584.922 -576.208 1205.16C-1186.59 2141.47 -241.051 980.651 527.661 1543.59C1060.95 1934.12 928.721 1407.34 1014.53 1162.32C1059.18 1034.83 1397.3 834.497 1311.52 715.042C1190.25 397.231 846.421 592.232 776.84 398.132Z"
                        fill="url(#paint1_linear_300_5588)"
                    />
                </g>
                <g filter="url(#filter3_f_300_5588)">
                    <path
                        d="M374.824 578.141C352.133 353.315 717.929 -122.3 589.158 -172.778C336.467 -271.832 -573.893 764.93 -978.225 1385.17C-1588.6 2321.48 -643.067 1160.66 125.645 1723.6C658.936 2114.13 526.705 1587.35 612.514 1342.33C657.163 1214.84 995.288 1014.51 909.501 895.05C788.23 577.239 444.405 772.24 374.824 578.141Z"
                        fill="url(#paint2_linear_300_5588)"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_f_300_5588"
                    x={-1365.56}
                    y={-2371.19}
                    width={2882.85}
                    height={4426.38}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation={95.9473}
                        result="effect1_foregroundBlur_300_5588"
                    />
                </filter>
                <filter
                    id="filter1_f_300_5588"
                    x={-1170.43}
                    y={-2336.58}
                    width={2481.13}
                    height={2910.73}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation={78.6454}
                        result="effect1_foregroundBlur_300_5588"
                    />
                </filter>
                <filter
                    id="filter2_f_300_5588"
                    x={-928.94}
                    y={-516.691}
                    width={2411.63}
                    height={2357.27}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation={78.6454}
                        result="effect1_foregroundBlur_300_5588"
                    />
                </filter>
                <filter
                    id="filter3_f_300_5588"
                    x={-1330.96}
                    y={-336.682}
                    width={2411.63}
                    height={2357.27}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation={78.6454}
                        result="effect1_foregroundBlur_300_5588"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_300_5588"
                    x1={1236.03}
                    y1={-895.03}
                    x2={-325.516}
                    y2={78.0308}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFF2E3" />
                    <stop offset={0.14059} stopColor="#FFBE82" />
                    <stop offset={0.645} stopColor="#FFBE82" />
                    <stop offset={1} stopColor="#FFDCBC" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_300_5588"
                    x1={1734.33}
                    y1={1202.8}
                    x2={787.97}
                    y2={-181.235}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.192317} stopColor="#F7CADC" />
                    <stop offset={0.38} stopColor="#DAD4FF" />
                    <stop offset={0.525} stopColor="#F7CADC" />
                    <stop offset={1} stopColor="white" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_300_5588"
                    x1={1332.31}
                    y1={1382.81}
                    x2={385.953}
                    y2={-1.22638}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.192317} stopColor="#F7CADC" />
                    <stop offset={0.38} stopColor="#DAD4FF" />
                    <stop offset={0.525} stopColor="#F7CADC" />
                    <stop offset={1} stopColor="white" stopOpacity={0} />
                </linearGradient>
            </defs>
        </svg>
    );
}
